enum TypeSecurite {
  PRESQU_ACCIDENT = "PRESQU_ACCIDENT",
  SITUATION_DANGEREUSE = "SITUATION_DANGEREUSE",
  ACCIDENT_BENIN = "ACCIDENT_BENIN",
}

export default TypeSecurite;
